import * as H from "history";
import { AccessPointProcessingStep } from "../models";
import { ImportSidePanelTab } from "../state";

/* eslint-disable */
export class ImportPageRouter {
  public openSidePanelRoute(history: H.History<unknown>, step: AccessPointProcessingStep, tab: ImportSidePanelTab): void {
    // const params = unquerystringify(history.location.search);
    // params.step = step;
    // params.tab = tab;
    // const search = queryString.stringify(params);
    // history.push({
    //   ...history.location,
    //   search,
    // });
  }

  public closeSidePanelRoute(history: H.History<unknown>): void {
    // const params = unquerystringify(history.location.search);
    // delete params.step;
    // delete params.tab;
    // const search = queryString.stringify(params);
    // history.push({
    //   ...history.location,
    //   search,
    // });
  }

  public openAddStepsRoute(history: H.History<unknown>): void {
    // const params = unquerystringify(history.location.search);
    // params.addSteps = true;
    // const search = queryString.stringify(params);
    // history.push({
    //   ...history.location,
    //   search,
    // });
  }

  public closeAddStepsRoute(history: H.History<unknown>): void {
    // const params = unquerystringify(history.location.search);
    // delete params.addSteps;
    // const search = queryString.stringify(params);
    // history.push({
    //   ...history.location,
    //   search,
    // });
  }
}
/* eslint-enable */
